import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Spinner } from '@/components/ui/FeedBack/Spinner';
export const ActionLoader = (props) => {
    const { className = '', spinnerColor = 'white', spinnerSize = 'xs' } = props;
    return (_jsx("div", Object.assign({ className: clsx('flex items-center justify-center', 'w-full h-full', 'absolute top-0 left-0', 'z-10', 'bg-gray-100/20', className) }, { children: _jsx(Spinner, { color: spinnerColor, size: spinnerSize }) })));
};
